import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ThemeProvider } from "@emotion/react";
import reportWebVitals from "./reportWebVitals";
import { theme } from "./theme";
import store from "./store/store";
import App from "./App";
import "./index.css";
import {  Provider as RollbarProvider, ErrorBoundary } from "@rollbar/react";
import rollbar from "./rollbarConfig";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <RollbarProvider instance={rollbar}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </RollbarProvider>
      </ThemeProvider>
    </React.StrictMode>
  </Provider>
);

reportWebVitals();
